import TableEditableComponent from 'components/elements/table/table';
import { ColumnDataType, IColumn } from 'components/elements/table/type';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

interface Props {
  parentIndex: number;
}

export default function GuestTable(props: Props) {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const name = `approvalable.flightSales.${props.parentIndex}.flightSaleGuests`;
  const value = useWatch({
    control,
    name,
  });

  const _columns: IColumn<any>[] = [
    {
      header: t('common:guest'),
      accessorKey: 'guestName',
      minSize: 250,
      dataType: ColumnDataType.text,
    },
    {
      header: t('common:ticket'),
      accessorKey: 'ticket',
      minSize: 100,
      dataType: ColumnDataType.text,
    },
    {
      header: t('guest:booking_preferences'),
      accessorKey: 'preferences',
      minSize: 250,
      dataType: ColumnDataType.tags,
      tagKeyName: 'label',
    },
  ];

  return (
    <div style={{ width: '100%' }}>
      <TableEditableComponent
        columns={_columns}
        data={value}
        dispatch={() => {}}
        disabled
        name={name}
      />
    </div>
  );
}
